import React from 'react';
import UserForm from '../components/User_Form';
import { Row, Col, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const Userform = () => {
  return (
    <div style={{ padding: '0px 0px 0px 20px' }}>
      <h3>Cadastro de Usuário</h3>
      <Breadcrumb style={{ marginBottom: 16 }}>
        <Breadcrumb.Item>
          <Link to="/">Início</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to="/users">Usuários</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Formulário</Breadcrumb.Item>
      </Breadcrumb>

      <Row>
        <Col xs={0} sm={0} md={24}>
          <UserForm />
        </Col>
        <Col xs={24} sm={24} md={0}>
          <UserForm />
        </Col>
      </Row>
    </div>
  );
};

export default Userform;
